var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0571 14.8305V23.7997C31.0571 24.1028 30.9367 24.3935 30.7223 24.6078C30.508 24.8221 30.2173 24.9425 29.9142 24.9425H2.48563C2.18253 24.9425 1.89184 24.8221 1.67751 24.6078C1.46318 24.3935 1.34277 24.1028 1.34277 23.7997V5.51395C1.34277 5.21085 1.46318 4.92016 1.67751 4.70583C1.89184 4.4915 2.18253 4.37109 2.48563 4.37109H16.5793",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9146 24.9424L11.6289 30.6567",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4854 24.9424L20.7711 30.6567",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34277 30.6562H23.0571",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9141 4.37096C21.9141 3.69285 22.1151 3.02997 22.4919 2.46614C22.8686 1.90232 23.4041 1.46287 24.0306 1.20337C24.6571 0.943868 25.3464 0.875971 26.0115 1.00826C26.6766 1.14056 27.2875 1.4671 27.767 1.94659C28.2465 2.42608 28.573 3.037 28.7053 3.70207C28.8376 4.36715 28.7697 5.05652 28.5102 5.68301C28.2507 6.3095 27.8113 6.84497 27.2474 7.22171C26.6836 7.59845 26.0207 7.79953 25.3426 7.79953V10.0852",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3429 15.7991C25.1914 15.7991 25.046 15.7389 24.9389 15.6317C24.8317 15.5246 24.7715 15.3792 24.7715 15.2277C24.7715 15.0761 24.8317 14.9308 24.9389 14.8236C25.046 14.7165 25.1914 14.6562 25.3429 14.6562",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3428 15.7991C25.4943 15.7991 25.6397 15.7389 25.7468 15.6317C25.854 15.5246 25.9142 15.3792 25.9142 15.2277C25.9142 15.0761 25.854 14.9308 25.7468 14.8236C25.6397 14.7165 25.4943 14.6562 25.3428 14.6562",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizActiveIcon);
export default __webpack_public_path__ + "static/media/quiz-active-icon.95cf252877e08f01414f0f9f813f3fab.svg";
export { ForwardRef as ReactComponent };